const FoxWallet = () => (
    <svg
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 1200 1200'
        xmlSpace='preserve'
        id='fox'
        fill='#fff'
    >
        <g>
            <path
                className='st0'
                d='M487.6,676.2c2.5,0.8,5,1.4,7.6,1.6c0,0-10.7,4-32.9-3.5c0,0-16.6-6.8-29-5.6c-14.4,1.3-24.4,20.1-24.4,20.1
		c2.9-1.5,5.9-2.7,9-3.6c9.8-2,6.4-0.3,6.4-0.3s-18.9,7.9-20.2,15c-0.3,1.8,5-3.2,19-2.8c17.2,0.5,32.1,10.5,38.3,12.2
		c12.6,3.4,30.6,4.1,47.2-8.8c0,0,15.3-9.6,20-27.3c1.2-4.9,1.9-9.9,2.1-15c0.1-4.5-0.4-8.9-1.3-13.2
		C529.3,644.9,520.4,665.6,487.6,676.2z'
            />
            <path
                className='st0'
                d='M812.6,870.4c33.3-41.8,51.5-93.7,51.5-147.1c0-53.5-18.2-105.3-51.5-147.1l213.6-23.5
		c0,0,22.2,60.9,28.1,93.4c0.8,4.2,2.1,12.6,2.1,12.6s-33.1,80.4-84,124.6C904,842.7,812.6,870.4,812.6,870.4z M306.9,867.5
		L225,882.6c-26-65.8-35.5-136.9-27.6-207.2c7.8-70.3,32.7-137.6,72.5-196.1c1.7-2.5,5.3-7.5,5.3-7.5l90.4,254.7L306.9,867.5z'
            />
            <path
                className='st1'
                d='M603,345.1c0.3-0.3,0.5-0.5,0.8-0.8c2.2-2.3,53-57-7.6-149.5C551.5,126.5,437.6,128.5,391.1,93
		c3.4,27.3,30.2,52,27.3,89.5c-1.1,12.3-3.4,24.6-6.9,36.5c-5.5,21.4-10.7,41.7-3,81.5c6,31.1,20.2,53.7,42.1,67.4
		c25.1,15.6,60,19,95.7,9.3C570.3,370.6,591.5,358.6,603,345.1L603,345.1z'
            />
            <path
                className='st1'
                d='M678.8,305.2c13.1-22.5,15.5-48.8,7.5-78c-11.2-40.7-32.5-67.4-49.7-88.9c-5.4-6.8-10.5-13.1-14.5-19.1
		c-16.4-24-23.4-53.1-19.8-81.9c-20.7,14.9-60.7,43.1-86.2,73.1c36.9,17.7,65.7,36.9,88.5,71.7c38.8,59.2,38.2,107,30.8,136.7
		c-2.1,8.2,13.6,15.4,10.7,21.8C659.3,331.2,670.5,319.1,678.8,305.2z'
            />
            <path
                className='st1'
                d='M1147,524.6c0,0-17.2,95.3-107.5,106.4c0,0-327.2-2.1-351.1,295.1l-5.5,83.5L290.4,895.2
		c0,0,37-126.2,117.9-227.5c0,0,137.4-194.1,529-143c0,0,45.7,9.2,109.9,15.2C1101.4,545,1147,524.6,1147,524.6z'
            />
            <path
                className='st0'
                d='M913.3,394.9c0,0-72.2-83-241.4-101.9c0,0-75-0.4-194.7-75.9c-61.5-38.8-86-124.3-86-124.3
		c-43.8,59.1-65.7,146.4-73.9,186.3c-1.9,6.7-3.6,13.5-5.3,20.5c-23.3-14.8-21.2-24.8-20.8-26c-0.9,2.7-40.6,118.3-33.6,203
		c3.9,47.8,29.5,92.1,29.5,92.1c-11.2,7.1-26.1-4.5-26.1-4.5c12.7,73,27.5,107.1,59.1,150.5c6.8,9.3,0.1,4.7-29.8,60.7
		c-26.1,48.8-48.6,116-48.6,116l70.8,3.8c0,0,58.2-168.3,123.5-233.1c84.7-77.6,196.8-136.9,394.4-125.9c0,0,87.9,10.7,131.2,14.8
		c0,0,143.6,11.4,183.3-26.5C1145,524.6,1034.7,525.8,913.3,394.9z M733.7,439.3c0,0,57.5-44.9,135.2-34l55.5,74
		C924.4,479.3,839.4,435.1,733.7,439.3z'
            />
            <path
                className='st0'
                d='M709.5,885.4c0,0,27.6,19.1,71.5,8.9c0,0-70.9,41.1-220.4-15.3c0,0-154.2-69-262.6-53.2
		c-69.7,10.1-131.3,65.5-168.7,107.7c-45.1,50.9-39.5,27.1,73.8,13.1c27.2-3.4,11.5,4.4,11.5,4.4s-151.3,63.4-161.5,119.8
		c-2.6,14.1,39.9-25.6,151.7-22.1c137.3,4.3,256.8,84.1,305.9,97.2c100.6,26.9,244.8,33,377.1-70.7c0,0,122.1-76.6,159.8-218.2
		c9.8-39.3,15.6-79.4,17.3-119.9c2-52.7-14-108.2-14-108.2S961.6,826.5,709.5,885.4z'
            />
        </g>
    </svg>
);

export default FoxWallet;
